import React, { FunctionComponent } from 'react'
import { IconRu } from './icons/ru'

interface FlagProps {
  className?: string
  code: string
}
export const Flag: FunctionComponent<FlagProps> = ({ className, code }) => {
  return code.toLowerCase() === 'ru' ? (
    <IconRu className={className} />
  ) : (
    /* eslint-disable-next-line @next/next/no-img-element  */
    <img
      src={`https://flagcdn.com/w20/${code.toLowerCase()}.png`}
      srcSet={`https://flagcdn.com/w20/${code.toLowerCase()}.png 2x`}
      className={className}
      alt={code}
    />
  )
}
